<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="store.exportPdf()"
                    ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="store.exportCsv()"
                    ><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#add_timesheet"
              @click="openAdd"
              v-can="'TimingSheets.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Today’s Work
            </a>
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Filters -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="row g-2 align-items-end">
            <div class="col-md-3">
              <label class="form-label"
                >Search (name/email/ID or project)</label
              >
              <input
                v-model="store.filters.search"
                type="text"
                class="form-control"
                placeholder="e.g. Jane, EMP-001, Office Mgmt"
              />
            </div>
            <div class="col-md-3">
              <label class="form-label">Employee</label>
              <select v-model="store.filters.employee_id" class="form-select">
                <option value="">All</option>
                <option
                  v-for="e in employeesForSelect"
                  :key="e.id"
                  :value="e.id"
                >
                  {{ e.label }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Status</label>
              <select v-model="store.filters.status" class="form-select">
                <option value="">All</option>
                <option>Draft</option>
                <option>Submitted</option>
                <option>Approved</option>
                <option>Rejected</option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label">From</label>
              <input
                v-model="store.filters.date_from"
                type="date"
                class="form-control"
              />
            </div>
            <div class="col-md-2">
              <label class="form-label">To</label>
              <input
                v-model="store.filters.date_to"
                type="date"
                class="form-control"
              />
            </div>
            <div class="col-md-2 d-grid">
              <button
                class="btn btn-primary"
                @click="store.fetchAll({ page: 1 })"
              >
                Filter
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Timesheet</h5>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <timesheets-table
              :rows="store.items"
              :loading="store.loading"
              :show-approve-actions="true"
              @edit="openEdit"
              @delete="confirmDelete"
              @bulk-delete="confirmBulkDelete"
              @approve="confirmApprove"
              @bulk-approve="confirmBulkApprove"
            />
          </div>
          <div class="p-3 d-flex justify-content-between align-items-center">
            <div>
              Showing page {{ store.pagination.current_page }} of
              {{ totalPages }}
            </div>
            <div class="btn-group">
              <button
                class="btn btn-outline-secondary"
                :disabled="store.pagination.current_page <= 1"
                @click="
                  store.fetchAll({ page: store.pagination.current_page - 1 })
                "
              >
                Prev
              </button>
              <button
                class="btn btn-outline-secondary"
                :disabled="store.pagination.current_page >= totalPages"
                @click="
                  store.fetchAll({ page: store.pagination.current_page + 1 })
                "
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>

  <timesheets-modal :edit-item="editItem" @saved="onSaved" />
</template>

<script setup>
import { computed, onMounted, ref, nextTick } from "vue";
import { useTimesheetStore } from "@/stores/timesheetStore";
import { useEmployeeStore } from "@/stores/employeeStore";
import TimesheetsTable from "./timesheets-table.vue";
import TimesheetsModal from "@/components/modal/timesheets-modal.vue";
import Modal from "bootstrap/js/dist/modal";

const title = "Timesheets";
const text = "HR";
const text1 = "Timesheets";

const store = useTimesheetStore();
const empStore = useEmployeeStore();
const editItem = ref(null);

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

const totalPages = computed(() => {
  const t = store.pagination.total || 0;
  const p = store.pagination.per_page || 25;
  return Math.max(1, Math.ceil(t / p));
});

function openAdd() {
  const el = document.getElementById("add_timesheet");
  Modal.getOrCreateInstance(el)?.show();
}

function openEdit(row) {
  editItem.value = row;
  nextTick(() => {
    Modal.getOrCreateInstance(
      document.getElementById("edit_timesheet")
    )?.show();
  });
}

// async function confirmDelete(row) {
//   if (!row?.id) return;
//   if (!confirm("Delete this timesheet?")) return;
//   await store.remove(row.id);
// }

async function confirmBulkDelete(ids) {
  if (!ids?.length) return;
  if (!confirm(`Delete ${ids.length} selected item(s)?`)) return;
  await store.bulkDelete(ids);
}

async function confirmApprove(row, status) {
  if (!row?.id) return;
  const label = status === "Approved" ? "approve" : "reject";
  if (!confirm(`${label.charAt(0).toUpperCase()}${label.slice(1)} this timesheet?`)) return;
  await store.approve(row.id, status);
}

async function confirmBulkApprove(ids, status) {
  if (!ids?.length) return;
  const label = status === "Approved" ? "approve" : "reject";
  if (!confirm(`${label.charAt(0).toUpperCase()}${label.slice(1)} ${ids.length} selected item(s)?`)) return;
  await store.bulkApprove(ids, status);
}

const employeesForSelect = computed(() =>
  (empStore.employees || []).map((e) => ({
    id: e.id,
    label: `${e?.user?.first_name ?? e.first_name ?? ""} ${
      e?.user?.last_name ?? e.last_name ?? ""
    } (${e.employee_id})`.trim(),
  }))
);

function onSaved() {
  editItem.value = null;
}

async function confirmDelete(row) {
  editItem.value = row;
  nextTick(() => {
    Modal.getOrCreateInstance(document.getElementById("delete_modal"))?.show();
  });
}

onMounted(async () => {
  if (!empStore.employees?.length) await empStore.fetchEmployees();
  await store.fetchAll();

  document
    .getElementById("edit_timesheet")
    ?.addEventListener("hidden.bs.modal", () => {
      editItem.value = null;
    });
});
</script>


